"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { Problem } from "./problem";
import { Solution } from "./solution";
import { CapabilityOverview } from "./capability-overview";
import { HowItWorks } from "./how-it-works";
import { CoreFeatures } from "./core-features";
import { AdvancedFeatures } from "./advanced-features";
import { StoryFrameworkBuilderSection } from "./story-framework-builder";
import { CognitiveBiasIntegrationSection } from "./cognitive-bias-integration";
import { UseCases } from "./use-cases";
import { Benefits } from "./benefits";
import { Usps } from "./usps";
import { WhoItsFor } from "./who-its-for";
import { WhyChooseUs } from "./why-choose-us";
import { RelatedCapabilities } from "./related-capabilities";
import { FAQ } from "./faq";
import { PAA } from "./paa";
import { Cta } from "./cta";

export function NarrativeEngineeringPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-purple">
        <ExecutiveSummary />
      </div>
      <Problem />
      <div className="bg-aurora-crimson">
        <Solution />
      </div>
      <CapabilityOverview />
      <div className="bg-aurora-emerald">
        <HowItWorks />
      </div>
      <CoreFeatures />
      <div className="bg-aurora-violet">
        <AdvancedFeatures />
      </div>
      <StoryFrameworkBuilderSection />
      <div className="bg-aurora-purple">
        <CognitiveBiasIntegrationSection />
      </div>
      <UseCases />
      <div className="bg-aurora-emerald">
        <Benefits />
      </div>
      <Usps />
      <div className="bg-aurora-denim">
        <WhoItsFor />
      </div>
      <WhyChooseUs />
      <RelatedCapabilities />
      <div className="bg-aurora-purple">
        <FAQ />
      </div>
      <PAA />
      <Cta />
    </>
  );
}
